import { render } from "./TriggerSceneSlide.vue?vue&type=template&id=648e0970&ts=true"
import script from "./TriggerSceneSlide.ts?vue&type=script&lang=ts"
export * from "./TriggerSceneSlide.ts?vue&type=script&lang=ts"

import "../SceneSlide.base.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__